import ForgotPasswordContainer from "./ForgotPasswordContainer";
export default ForgotPasswordContainer;
